import styles from './Checkout.module.css';

const FIELDS = [
  { name: 'name', placeholder: 'Full name', autoComplete: 'name' },
  { name: 'phone', placeholder: 'Phone', autoComplete: 'tel', type: 'tel' },
  { name: 'addr', placeholder: 'Street address', autoComplete: 'street-address', full: true },
  { name: 'city', placeholder: 'City', autoComplete: 'address-level2' },
  { name: 'pin', placeholder: 'PIN code', autoComplete: 'postal-code', inputMode: 'numeric' },
];

export function AddressSection({ step = 1, address, onChange }) {
  return (
    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <span className={styles.step}>{step}</span>Delivery address
      </h2>

      <div className={styles.fieldGrid}>
        {FIELDS.map(({ name, placeholder, full, ...rest }) => (
          <div key={name} className={full ? styles.full : undefined}>
            <label className="sr-only" htmlFor={`addr-${name}`}>
              {placeholder}
            </label>
            <input
              id={`addr-${name}`}
              className={styles.input}
              value={address[name]}
              onChange={(e) => onChange(name, e.target.value)}
              placeholder={placeholder}
              {...rest}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
